const PREFIX = 'muulti-mint-uploads:';
const MAX_AGE = 30 * 24 * 60 * 60 * 1000;
// Public upload receipts only, scoped by the wallet, creator, component, collection,
// network and exact template revision. This is never an access credential.
export function readMintUploads(key) {
    try {
        const saved = JSON.parse(sessionStorage.getItem(PREFIX + key));
        if (saved?.key !== key || !Number.isFinite(saved.savedAt) || Date.now() - saved.savedAt > MAX_AGE) return null;
        if ((saved.imageUri && typeof saved.imageUri !== 'string') || (saved.metadataUri && typeof saved.metadataUri !== 'string')) return null;
        return { key, imageUri: saved.imageUri || '', metadataUri: saved.metadataUri || '', contentType: saved.contentType || 'image/png' };
    } catch { return null; }
}
export function saveMintUploads(uploads) {
    try {
        sessionStorage.setItem(PREFIX + uploads.key, JSON.stringify({ key: uploads.key, imageUri: uploads.imageUri || '',
            metadataUri: uploads.metadataUri || '', contentType: uploads.contentType || 'image/png', savedAt: Date.now() }));
    } catch { /* Keep the existing in-memory receipts when browser storage is unavailable. */ }
}
export function clearMintUploads(key) {
    try { sessionStorage.removeItem(PREFIX + key); } catch { /* Optional retry cache. */ }
}
